<template>
  <div class="footer-wrapper">
    <div class="footer container">
      <div class="footer-top">
        <div class="footer-top-logo">
          <a target="_blank" href="http://eyejackapp.com"><img src="../assets/footer-logo-white.png" /></a>
        </div>
        <div class="footer-top-partners">
          <p>Partners</p>
           <a target="_blank" href="http://codeoncanvas.cc"><img src="../assets/COC.png" /></a>
        </div>
      </div>

      <div class="separator" />
      <div class="footer-bottom">
        <div class="footer-bottom-socials">
          <a
            id="instagram"
            target="_blank"
            href="https://www.instagram.com/eyejackapp/"
            ><img src="../assets/instagram-white.png"
          /></a>
          <a
            id="facebook"
            target="_blank"
            href="https://www.facebook.com/eyejackapp/"
            ><img src="../assets/facebook-white.png"
          /></a>
          <a id="mail" target="_blank" href="mailto:info+traitz@eyejackapp.com"
            ><img src="../assets/mail-white.png"
          /></a>
        </div>
        <div class="footer-bottom-terms">
          <p>© 2021 EyeJack. All rights reserved.</p>
          <p>
            <a target="_blank" href="https://eyejackapp.com/pages/privacy"
              >Privacy
            </a>
          </p>
          <p>
            <a target="_blank" href="https://eyejackapp.com/pages/terms"
              >Terms</a
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style lang="scss" scoped>
@import "../styles/styles.scss";

.footer-wrapper {
  background: #1c1c1c;
  .footer {
    margin: auto;
    &-top {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      padding-bottom: 50px;
      padding-top: 50px;
      @include media(">=tablet") {
        padding-top: 100px;
      }
      &-logo {
        img {
          max-width: 69px;
          max-height: 38px;
        }
      }
      &-partners {
        p {
          font-size: 16px;
          font-weight: 400;
          letter-spacing: 1.55px;
          color: white;
          margin-bottom: 25px;
        }
        img {
          max-width: 50px;
          max-height: 50px;
        }
      }
    }

    .separator {
      border: 1px solid #575757;
    }

    &-bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 45px 0 50px 0;
      @include media(">=tablet") {
        padding: 45px 0 100px 0;
      }
      &-socials {
        display: flex;
        flex-direction: row;
        align-items: center;
        a {
          justify-content: center;
          img {
            width: 30px;
            height: auto;
          }
          margin-right: 25px;
          @include media(">=tablet") {
            margin-right: 50px;
          }
        }
        #mail {
          img {
            max-width: 35px;
          }
        }
      }
      &-terms {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        p {
          font-size: 16px;
          font-weight: 400;
          letter-spacing: 1.55px;
          margin-left: 50px;
          color: #9e9e9e;
          padding: 5px 0;
        }
        a {
          color: #9e9e9e;
        }
        a:hover {
          color: white;
        }
      }
    }
  }
}
</style>
